import http from '../utils/fetch'

export default {
  getCarts (page, cb, errorCb) {
    http.get({url: `carts?page=${page - 1}`})
      .then((res) => {
        cb(res)
      }, (res) => {
        errorCb(res)
      })
  },
  addCart (cart, isOverride, cb, errorCb) {
    http.post({
      url: `carts?isOverride=${isOverride}`,
      data: cart
    }).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  },
  /**
   * kkk 批量加入购物车
   * @param cart
   * @param cb
   * @param errorCb
   */
  addCarts (cart, isOverride, cb, errorCb) {
    http.post(
      {
        url: 'carts/batch?isOverride=false',
        data: cart
      }).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  },
  updateCart (cart, cb, errorCb) {
    http.patch({
      url: 'carts',
      data: cart
    }).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  },
  removeCart (cartId, cb, errorCb) {
    // Vue.$http.options.emulateHTTP = true
    http.delete({url: `carts/${cartId}`})
      .then((res) => {
        cb(res)
      }, (res) => {
        errorCb(res)
      })
  },
  removeCartByBatch (cartIds, cb, errorCb) {
    // Vue.$http.options.emulateHTTP = true
    http.delete({
      url: 'carts',
      data: cartIds
    }).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/cart.js